var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { DiffTooltip, useDiffTooltip } from '@web/components/ui/Diff/DiffTooltip';
import { cx } from '@web/utility';
export var periodDiffColor = function (diff) {
    if (diff > 0) {
        return 'text-emerald-600';
    }
    if (diff < 0) {
        return 'text-rose-600';
    }
    return 'text-slate-500';
};
export var PeriodDiff = function (_a) {
    var diff = _a.diff, _b = _a.className, className = _b === void 0 ? 'text-xs font-medium' : _b, _c = _a.prefixSpace, prefixSpace = _c === void 0 ? true : _c, arrowColor = _a.arrowColor;
    var _d = useDiffTooltip(diff, {
        arrowColor: arrowColor
    }), tooltipText = _d.tooltipText, tooltipId = _d.tooltipId;
    if (!diff) {
        return null;
    }
    var label = (_jsx("span", __assign({ className: cx(className, periodDiffColor(diff.diff), 'tabular-nums', {
            'cursor-pointer': Boolean(tooltipText)
        }) }, { children: diff.diffString })));
    return (_jsxs(_Fragment, { children: [prefixSpace ? ' ' : null, _jsx(DiffTooltip, __assign({ text: tooltipText, id: "periodDiff-".concat(tooltipId) }, { children: label }))] }));
};
